import React from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from './MaterialIcon';
import './LoadingStatusPanel.css';

const LoadingStatusPanel = ({ isVisible, progress, messages = [], onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-status-panel">
      <div className="loading-header">
        <div className="loading-title">
          <MaterialIcon icon="sync" size={20} className="loading-icon" />
          <span>Loading Progress</span>
        </div>
        {onClose && (
          <button className="loading-close-btn" onClick={onClose}>
            <MaterialIcon icon="close" size={16} />
          </button>
        )}
      </div>

      <div className="loading-content">
        {/* Current Progress */}
        {progress && (
          <div className="progress-section">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{
                  width: `${progress.current > 0 ? (progress.current / progress.total) * 100 : 0}%`,
                }}
              />
            </div>
            <div className="progress-text">
              {progress.message}
              {progress.current > 0 && progress.total > 0 && (
                <span className="progress-count">
                  ({progress.current} / {progress.total})
                </span>
              )}
            </div>
          </div>
        )}

        {/* Recent Messages */}
        {messages.length > 0 && (
          <div className="messages-section">
            <div className="messages-header">
              <MaterialIcon icon="info" size={16} />
              <span>Recent Activity</span>
            </div>
            <div className="messages-list">
              {messages
                .slice(-10)
                .reverse()
                .map((message, index) => (
                  <div key={index} className={`message-item ${message.type || 'info'}`}>
                    <MaterialIcon
                      icon={
                        message.type === 'error'
                          ? 'error'
                          : message.type === 'success'
                            ? 'check_circle'
                            : 'info'
                      }
                      size={14}
                    />
                    <span className="message-text">{message.text}</span>
                    {message.timestamp && (
                      <span className="message-time">
                        {new Date(message.timestamp).toLocaleTimeString()}
                      </span>
                    )}
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

LoadingStatusPanel.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    message: PropTypes.string,
  }),
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      type: PropTypes.oneOf(['info', 'success', 'error', 'warning']),
    })
  ),
  onClose: PropTypes.func,
};

export default LoadingStatusPanel;
